import { StatusStyle, ClipCompositionStatusType } from './types';

export const STATUS_STYLES: Record<Exclude<ClipCompositionStatusType, 'done'>, StatusStyle> = {
  failed: {
    bgColor: 'bg-yellow-100',
    textColor: 'text-yellow-800',
    icon: 'IconAlertTriangle',
    message:
      'We ran into an issue while processing the high quality recordings of {{names}}. You can still download a lower quality version now.'
  },
  processing: {
    bgColor: 'bg-blue-100',
    textColor: 'text-blue-800',
    icon: 'IconAlertCircle',
    message:
      "We're processing some recordings for the best quality. You can still download a lower quality version now."
  },
  uploading: {
    bgColor: 'bg-blue-100',
    textColor: 'text-blue-800',
    icon: 'IconAlertCircle',
    message: 'Some recordings are uploading or need to be uploaded. You can still download a lower quality version now.'
  }
};
